export default function extractTemplateContent (template) {
    template.parentElement.appendChild(document.importNode(template.content, true));

    template.parentElement.dispatchEvent(new CustomEvent('lazyContentLoaded', {
        detail: {},
        bubbles: true,
        cancelable: true
    }));
    template.remove();
};